<template>
  <div id="my_map"></div>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapState } from "vuex";

export default {
  name: "rotation-web-map",
  props: {},
  data() {
    return {
      centerZip: {},
      rotationColor: "",
      zipObjectsInTerritory: [],
      zipCodesAsArray: [],
      zipCodesAsString: "",
      rotationZipObjectsInTerritory: [],
      rotationZipCodesAsArray: [],
      rotationZipCodesAsString: ""
    };
  },
  computed: {
    ...mapState(["territory", "globals"])
  },
  watch: {
    "$store.state.globals.query_by_zip": function(newValue, oldValue) {
      if (newValue) {
        this.refreshWait(newValue);
      }
    },
    "$store.state.globals.query_by_zip_radius": function(newValue, oldValue) {
      if (newValue) {
        this.refreshWait(newValue);
      }
    }
  },
  methods: {
    refreshWait(newZip) {
      if (this.$store.state.globals.query_by_zip.length == 5) {
        if (this.timer) {
          window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(() => {
          this.timer = null;
          this.loadMap(this);
        }, 2000);
      }
    },
    async changeGlobalZipObject(newZip) {
      await this.$store.dispatch("globals/setQueryByZipObject", newZip);
      await this.$store.dispatch("zip/getUsageMap", newZip);
    },
    hexToRGBA(hex, opacity) {
      return (
        "rgba(" +
        (hex = hex.replace("#", ""))
          .match(new RegExp("(.{" + hex.length / 3 + "})", "g"))
          .map(function(l) {
            return parseInt(hex.length % 2 ? l + l : l, 16);
          })
          .concat(opacity || 1)
          .join(",") +
        ")"
      );
    },
    async getCenter() {
      await this.$store
        .dispatch(
          "territory/GetZipCoordinates",
          this.$store.state.globals.query_by_zip
        )
        .then(response => {
          this.centerZip = response.data["GetCoordinatesResult"];
        });
    },
    // async loadTerritoryZips() {
    //   await this.$store
    //     .dispatch(
    //       "territory/GetTerritoryZips",
    //       this.$store.state.territory.territory_edit
    //     )
    //     .then((response) => {
    //       this.zipObjectsInTerritory = response.data["ZipsInTerritoryResult"];
    //       this.zipCodesAsArray = this.zipObjectsInTerritory.map(
    //         (a) => a.ZipCode
    //       );
    //       this.zipCodesAsString = this.zipCodesAsArray.toString();
    //     });
    // },
    // async loadRotationZips() {
    //   await this.$store
    //     .dispatch(
    //       "territory/GetRotationZips",
    //       this.$store.state.territory.rotation_edit
    //     )
    //     .then((response) => {
    //       this.rotationZipObjectsInTerritory =
    //         response.data["ZipsInRotationResult"];
    //       this.rotationZipCodesAsArray = this.rotationZipObjectsInTerritory.map(
    //         (a) => a.ZipCode
    //       );
    //       this.rotationZipCodesAsString = this.rotationZipCodesAsArray.toString();
    //     });
    // },
    async loadMap(_vue) {
      //await this.loadTerritoryZips();
      //await this.loadRotationZips();

      await this.getCenter().then(() => {
        loadModules(
          [
            "esri/Map",
            "esri/views/MapView",
            "esri/layers/FeatureLayer",
            "esri/layers/GraphicsLayer",
            "esri/Graphic",
            "esri/Color"
          ],
          { css: true }
        ).then(
          ([
            ArcGISMap,
            MapView,
            FeatureLayer,
            GraphicsLayer,
            Graphic,
            Color
          ]) => {
            const territorymap = new ArcGISMap({
              basemap: "topo"
            });

            var zipcodes = new FeatureLayer({
              url:
                "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/USA_ZIP_Codes/FeatureServer/0"
            });

            var graphicsLayer = new GraphicsLayer();
            territorymap.add(graphicsLayer);

            var centerzip_graphicsLayer = new GraphicsLayer();
            territorymap.add(centerzip_graphicsLayer);

            var dynamicGraphicsLayer = new GraphicsLayer({ id: "dynamic" });
            territorymap.add(dynamicGraphicsLayer);

            var mouseover_graphicsLayer = new GraphicsLayer({
              labelingInfo: [zipcodeLabels]
            });
            territorymap.add(mouseover_graphicsLayer);

            var view = new MapView({
              container: "my_map",
              map: territorymap,
              center: [this.centerZip.Longitude, this.centerZip.Latitude],
              zoom: 6
            });

            //var _whereClause = "ZIP = " + this.centerZip.ZipCode;
            var _whereClause =
              "ZIP = '" + _vue.$store.state.globals.query_by_zip + "'";
            //console.log(_whereClause);
            var _whereClauseTerritoryZips = "1=1";
            //  "ZIP in (" + this.zipCodesAsString + ")";

            var _whereRotationZips =
              "ZIP in (" + this.rotationZipCodesAsString + ")";

            view.when(function() {
              var centerZipQuery = {
                geometry: view.center,
                distance: _vue.$store.state.globals.query_by_zip_radius,
                units: "miles",
                spatialRelationship: "intersects",
                outFields: ["ZIP"],
                returnGeometry: true,
                where: _whereClause
              };
              zipcodes
                .queryFeatures(centerZipQuery)
                .then(function(result) {
                  //addGraphics(result, true);
                  zoomToGraphics(result, true);
                })
                .then(function() {
                  var query = {
                    //geometry: view.center,
                    distance: 1,
                    units: "miles",
                    spatialRelationship: "intersects",
                    //spatialRelationship: "touches",
                    //outFields: ["ZIP", "AGE_55_64"],
                    //outFields: ["ZIP"],
                    returnGeometry: true,
                    //returnGeometry: false,
                    where: _whereClause
                    //where: _whereClauseTerritoryZips,
                  };
                  //console.log(query);
                  zipcodes.queryFeatures(query).then(function(result) {
                    addCenterZipGraphic(result, true);
                  });
                })
                .then(function() {
                  var edit_query = {
                    geometry: view.center,
                    distance: _vue.$store.state.globals.query_by_zip_radius,
                    units: "miles",
                    spatialRelationship: "intersects",
                    outFields: ["ZIP", "AGE_55_64"],
                    returnGeometry: false
                    //where: _whereClauseTerritoryZips,
                  };
                  zipcodes.queryFeatures(edit_query).then(function(result) {
                    addMapGraphics(result, true);
                    //addTempGraphics(result, true);
                  });
                });
            });

            function zoomToGraphics(result) {
              result.features.forEach(function(feature) {
                view.goTo(feature.geometry).then(function() {
                  view.scale = 24000;
                  view.zoom = 9;
                });
                graphicsLayer.removeAll();
              });
            }

            function queryFeatureLayer(
              point,
              distance,
              spatialRelationship,
              sqlExpression
            ) {
              var query = {
                geometry: point,
                distance: distance,
                units: "miles",
                spatialRelationship: spatialRelationship,
                outFields: ["ZIP", "AGE_55_64"],
                returnGeometry: true,
                where: sqlExpression
              };
              zipcodes.queryFeatures(query).then(function(result) {
                addGraphics(result, true);
              });
            }

            view.on("pointer-move", function(evt) {
              var screenPoint = {
                x: evt.x,
                y: evt.y
              };

              view.hitTest(screenPoint).then(function(response) {
                getHoverGraphics(response);
              });
            });

            view.on("click", function(evt) {
              var screenPoint = {
                x: evt.x,
                y: evt.y
              };

              view.hitTest(screenPoint).then(function(response) {
                getGraphics(response);
              });
            });

            function getGraphics(response) {
              if (response.results.length) {
                var _handled = false;
                response.results.forEach(function(_result) {
                  //_vue.$store.dispatch(
                  //  "globals/setQueryByZip",
                  //  _result.graphic.attributes.ZIP
                  //);
                  if (!_handled && _result.graphic.layer.id === "dynamic") {
                    if (_result.graphic.symbol.color == _temp_color) {
                      _result.graphic.symbol = _tempUnSelectedSymbol;
                    } else {
                      _result.graphic.symbol = _tempSelectedSymbol;
                    }

                    _handled = true;
                  }
                });
              }
            }

            function getHoverGraphics(response) {
              if (response.results.length) {
                var graphic = response.results[0].graphic;
                addSingleGraphic(graphic);
                _vue.changeGlobalZipObject(graphic.attributes.ZIP);
              }
            }

            function addSingleGraphic(graphic) {
              mouseover_graphicsLayer.removeAll();
              // var g = new Graphic({
              //   geometry: graphic.geometry,
              //   attributes: graphic.attributes,
              //   symbol: {
              //     type: "simple-fill", // autocasts as new SimpleFillSymbol()
              //     color: [255, 128, 0, 0.7],
              //     outline: {
              //       // autocasts as new SimpleLineSymbol()
              //       width: 1,
              //       color: "black"
              //     }
              //   }
              // });

              var h = new Graphic({
                geometry: graphic.geometry,
                attributes: graphic.attributes,
                symbol: {
                  type: "text",
                  text: graphic.attributes["ZIP"],
                  font: {
                    size: 10,
                    weight: "bold"
                  }
                }
              });

              //mouseover_graphicsLayer.add(g);
              mouseover_graphicsLayer.add(h);
              //dynamicGraphicsLayer.add(g);
            }

            var zipcodeLabels = {
              symbol: {
                type: "text",
                color: "#000",
                font: {
                  size: "8px",
                  family: "Noto Sans",
                  style: "italic",
                  weight: "normal"
                }
              },
              labelPlacement: "center-center",
              labelExpressionInfo: {
                expression: "$feature.ZIP"
              }
            };

            var _color = new Color([255, 0, 0, 0.8]);
            var _temp_color = new Color([0, 0, 255, 1]);
            var _default_color = new Color([255, 255, 255, 0.1]);
            var _territorySymbol = {
              type: "simple-fill",
              color: _color,
              outline: {
                width: 1,
                color: "black"
              }
            };

            var _tempSelectedSymbol = {
              type: "simple-fill",
              color: _temp_color,
              outline: {
                width: 1,
                color: "white"
              }
            };

            var _tempUnSelectedSymbol = {
              type: "simple-fill",
              color: _default_color,
              outline: {
                width: 1,
                color: "blue"
              }
            };

            var _nonTerritorySymbol = {
              type: "simple-fill",
              color: _default_color,
              outline: {
                width: 1,
                color: "black"
              }
            };

            function addMapGraphics(result) {
              var _ziplist = "-1";
              result.features.forEach(function(feature) {
                _ziplist += "," + feature.attributes["ZIP"];
              });

              var _newWhereClauseZips = "ZIP in (" + _ziplist + ")";

              var real_query = {
                outFields: ["ZIP"],
                returnGeometry: true,
                where: _newWhereClauseZips
              };
              zipcodes.queryFeatures(real_query).then(function(result) {
                addGraphics(result, true);
              });
            }

            function addGraphics(result) {
              result.features.forEach(function(feature) {
                var g = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  symbol: _nonTerritorySymbol
                });

                var h = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  symbol: _tempUnSelectedSymbol
                });

                graphicsLayer.add(g);
                dynamicGraphicsLayer.add(h);
              });

              result.features.forEach(function(feature) {
                if (
                  _vue.$store.state.zip.zip_symbols.find(
                    ele => ele.ZipCode === feature.attributes["ZIP"]
                  )
                ) {
                  var _pColor = _vue.$store.state.zip.zip_symbols.find(
                    ele => ele.ZipCode === feature.attributes["ZIP"]
                  ).SymbolColor;

                  var _localSymbol = {
                    type: "simple-fill",
                    color: _pColor,
                    outline: {
                      width: 1,
                      color: "black"
                    }
                  };
                  var g = new Graphic({
                    geometry: feature.geometry,
                    attributes: feature.attributes,
                    //symbol: _nonTerritorySymbol,
                    symbol: _localSymbol
                  });

                  graphicsLayer.add(g);
                }
              });
            }

            function addCenterZipGraphic(result) {
              if (result.features.length === 0) {
                alert("Zip Not Found");
              }
              result.features.forEach(function(feature) {
                var g = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  symbol: _territorySymbol
                });

                var h = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  symbol: {
                    type: "text",
                    text: feature.attributes["ZIP"],
                    color: "white",
                    font: {
                      size: 10,
                      weight: "bold"
                    }
                  }
                });

                centerzip_graphicsLayer.add(g);
                //centerzip_graphicsLayer.add(h);
              });
            }

            function addEditGraphics(result) {
              result.features.forEach(function(feature) {
                var g = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  symbol: _territorySymbol
                });

                graphicsLayer.add(g);
              });
            }
          }
        );
      });
    }
  },
  mounted() {
    if (this.$store.state.territory.rotation_edit.RotationID > 0) {
      this.rotationColor = this.hexToRGBA(
        this.$store.state.territory.rotation_edit.RotationColor,
        1
      );
      this.loadMap(this);
    }
  }
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}
#my_map {
  padding: 0;
  margin: 0;
  width: 100%;
  min-height: 600px;
  box-sizing: content-box;
  display: flex;
  line-height: normal;
}
</style>
